import { gsap } from "gsap";

import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { playSound, stopAmbSounds } from "../../../../../abstracts/utils/SoundUtils";
import { DDDSoundNames } from "../../../../assetsLoader/DDDAssetsNames";
import { DDDFreespinIntroScreen } from "./DDDFreespinIntroScreen";

export class DDDFreespinRestoreScreen extends DDDFreespinIntroScreen {
    constructor(parentContainer: AbstractView, name: string = `DDDFreespinRestoreScreen`) {
        super(parentContainer, name);
    }

    public override getGsapAnimation(fsLeft: number = 0): gsap.core.Timeline {
        this.fsLeftText.updateValue(`${fsLeft}`);

        const tl = gsap.timeline({ autoRemoveChildren: true });

        const showScreenTween = gsap.fromTo(
            this,
            { alpha: 0 },
            {
                alpha: 1,
                duration: 0.01,
                onStart: () => {
                    this.addChild(this.continueButton);
                    this.backgroundSpine.getSpineTween(this.getTweenName());

                    playSound({ name: this.getIntroStartSoundName() });
                    playSound({ name: this.getIntroLoopSoundName(), repeat: -1 });
                    stopAmbSounds();
                },
            }
        );

        tl.add(showScreenTween);

        return tl;
    }

    protected getIntroStartSoundName(): string {
        return DDDSoundNames.FS_INTRO_START;
    }

    protected getIntroLoopSoundName(): string {
        return DDDSoundNames.FS_INTRO_LOOP;
    }
}
